$(document).ready(function () {
    const debug = true;
    const log = (() => {
      const colors = {
        info: "#3498db",
        success: "#2ecc71",
        error: "#e74c3c",
      };
  
      const logFn = (type, ...args) => {
        if (debug) {
          console.log(
            `%cNP-LPFocuspatchPet`,
            `background: ${colors[type]}; color: white; padding: 2px 5px; border-radius: 3px;`,
            ...args
          );
        }
      };
  
      return {
        info: (...args) => logFn("info", ...args),
        success: (...args) => logFn("success", ...args),
        error: (...args) => logFn("error", ...args),
      };
    })();

    function parsePrice(priceString) {
      const price = parseFloat(priceString.replace(/[^\d.-]/g, '')) * 100;
      return price;
    }
  
    function initScrolling() {
      $(".lp-tr--learn-more-btn").click(function () {
        $(".lp-tr--scroll-to-learn").fadeIn("slow");
  
        const sectionHeight = $(
          ".lp-tr--why-kids-love-np-section"
        ).outerHeight();
        const sectionOffsetTop = $(".lp-tr--why-kids-love-np-section").offset()
          .top;
  
        $(window).scroll(function () {
          let scrollTopj = $(window).scrollTop();
          let scrollPoint = sectionOffsetTop + sectionHeight;
          if (scrollTopj >= scrollPoint) {
            $(".lp-tr--scroll-to-learn").fadeOut("fast");
          }
        });
      });
  
      log.success("Scrolling initialized");
    }
  
    function initTooltips() {
      $(".bundle-save-tooltip-box").on("click", function () {
        $(".bundle-save-tooltip-box").tooltip("show");
        setTimeout(() => {
          log.info("Updating tooltip");
          $(".bundle-save-tooltip-box").tooltip("update");
        }, 50);
      });
      $(".bundle-save-tooltip-box").on("show.bs.tooltip", function () {
        $(this).tooltip("update");
        $("#blur").fadeIn();
        log.info("Tooltip shown");
      });
      $(".bundle-save-tooltip-box").on("hide.bs.tooltip", function () {
        $("#blur").fadeOut();
        log.info("Tooltip hidden");
      });
  
      $("#blur").on("click", function (e) {
        $(".bundle-save-tooltip-box").tooltip("hide");
      });
  
      $('[data-toggle="tooltip"]').tooltip({
        container: ".form-group",
        boundary: ".form-group",
        animated: true,
        placement: "top",
        trigger: "manual",
        delay: { show: 100, hide: 100 },
      });
      log.success("Tooltips initialized");
    }

    // Second Product (Adults) functionality
    let currentSecondProdID = '';
    let isSecondProdActive = false;
    let updateFormCallback = null;

    // Primary Product functionality
    let currentPrimaryProdID = '';
    let isPrimaryProdActive = false;

    function initSecondProdHandlers() {
      log.info("initSecondProdHandlers()");

      // Dropdown toggle
      $('.second_prod-pack--dropdown-toggle').on('click', function(){
        $('.second_prod-pack--container').toggleClass('active');
        $('.second_prod-pack-content').slideToggle();
        log.info("Second product dropdown toggled");
      });

      // Second product pack selection
      $('.second_prod-pack-btns li').on('click', function(){
        const packEl = $(this);

        if (packEl.hasClass('active')) {
          // Only allow deselection if primary is active
          if (!isPrimaryProdActive) {
            log.info("Cannot deselect second product - at least one product required");
            return;
          }

          // Deselect if already active
          packEl.removeClass('active');
          currentSecondProdID = '';
          isSecondProdActive = false;
          log.info("Second product deselected");
        } else {
          // Select this pack
          $('.second_prod-pack-btns li').removeClass('active');
          packEl.addClass('active');
          currentSecondProdID = packEl.find('input').val();
          isSecondProdActive = true;
          log.info(`Second product selected: ${currentSecondProdID}`);
        }

        // Trigger form update
        if (updateFormCallback) {
          updateFormCallback();
        }
      });

      log.success("Second product handlers initialized");
    }

    function initFormBindings() {
      log.info("initFormBindings()");
  
      const priceNumEl = $(".overall-price .price-num");
      const priceOffEl = $(".overall-price .price-off, .pet-zenp--b-s-pack-percent-off .price-off");
      const priceCompareEl = $(".compare-price");
      const priceSavedEl = $(".saved-price");
      const petLocket = $('#petlocket');
  
      function isPetLocketChecked() {
        return petLocket.is(":checked");
      }
  
      function updateTotals() {
        log.info('updateTotals()');
        const totals = window.LPProductForm.getTotal();
        const formatted = totals.formatted;
        priceNumEl.text(formatted.price);
        priceOffEl.text(formatted.percentageOff);
        priceCompareEl.text(formatted.compareAtPrice);
        priceSavedEl.text(formatted.saved);
  
        if (formatted.hasSubscriptions === true) {
          log.info('hasSubscriptions');
          const subscriptionPrice = formatted?.subscriptionPrice;
          $('.loc_gated_selling_plan__subscription_info').removeClass('hidden');
          $('.subscription-price').text(subscriptionPrice);
        } else {
          $('.loc_gated_selling_plan__subscription_info').addClass('hidden');
        }
      }
  
      function updatePackPrices() {
        log.info("updatePackPrices()");
        const packs = $('.packs input[type="radio"]');
        packs.each(function () {
          const packInp = $(this);
          const pack = packInp.closest(".packs");
          const packQty = packInp.val();
          let packPrice = parsePrice(packInp.attr("data-price")) / packQty;
          let packCompareAtPrice = parsePrice(packInp.attr("data-compare-at-price")) / packQty;
          const packSellingPlanId = packInp.attr("data-selling-plan-id");
          
          if (packSellingPlanId > 0) {
            log.info(`Using subscription ID: ${packSellingPlanId}`);
            const packSellingPlanPercentOff = packInp.attr("data-subscription-percent-off");
            log.info(`Using subscription percent off: ${packSellingPlanPercentOff}`);
            packPrice = packPrice * (1 - packSellingPlanPercentOff / 100);
            log.info(`New pack price: ${packPrice}`);
            packCompareAtPrice = packCompareAtPrice * (1 - packSellingPlanPercentOff / 100);
  
            pack.find(".lp-tr--pack-price").text(`${Shopify.formatMoney(packPrice)} Each`); 
          }
        });
      }
  
      window.addEventListener("locGateSubsAdded", (event) => {
        updatePackPrices();
      });
      if (window.locGated === true) {
        updatePackPrices();
      }
  
      function updateForm() {
        const selectedRadio = $('.packs input[type="radio"]:checked');

        // Handle primary product if selected
        if (selectedRadio.length && isPrimaryProdActive) {
          const currentId = selectedRadio.attr("data-tick-id");
          const currentName = selectedRadio.attr("data-name");
          const price = parsePrice(selectedRadio.attr("data-price"));
          const compareAtPrice = parsePrice(selectedRadio.attr("data-compare-at-price"));
          const sellingPlanId = selectedRadio.attr("data-selling-plan-id");
          const sellingPlanPercentOff = selectedRadio.attr("data-subscription-percent-off");
          log.info(`updateForm() - Primary option selected: ${currentName}`);
  
          console.log("[ZenpatchPet] Setting SKUs with prices:", { price, compareAtPrice, name: currentName });
          window.LPProductForm.setSKUs([
            {
              sku: currentId,
              quantity: 1,
              name: currentName,
              price: price,
              compareAtPrice: compareAtPrice,
              sellingPlanId: sellingPlanId,
              sellingPlanPercentOff: sellingPlanPercentOff,
            },
          ]);
  
          // Disable the pet locket if the user selects the bundle that already has it
          if (selectedRadio.val() === "5") {
            petLocket.prop("disabled", true);
            petLocket.prop("checked", false);
          } else {
            petLocket.prop("disabled", false);
          }
        } else if (isSecondProdActive && currentSecondProdID) {
          // If no primary but secondary is selected, start with secondary
          const selectedSecondProdEl = $('.second_prod-pack-btns li.active');
          if (selectedSecondProdEl.length) {
            const packNumber = selectedSecondProdEl.find('.second_prod-pack-number').text().trim();
            const packPrice = selectedSecondProdEl.find('input').attr('data-price');
            const packCompareAtPrice = selectedSecondProdEl.find('input').attr('data-compare-at-price');

            log.info(`updateForm() - Only secondary product selected`);
            window.LPProductForm.setSKUs([
              {
                sku: currentSecondProdID,
                quantity: 1,
                name: `Dog Allergy Stickers - ${packNumber}`,
                price: parsePrice(packPrice || selectedSecondProdEl.find('.second_prod-pack-price').text()),
                compareAtPrice: parsePrice(packCompareAtPrice || packPrice || selectedSecondProdEl.find('.second_prod-pack-price').text()),
              }
            ]);
            log.info(`Set cart with only second product: ${currentSecondProdID}`);
          }

          petLocket.prop("disabled", false);
        } else {
          // No products selected - this shouldn't happen but handle gracefully
          log.error("No products selected!");
          window.LPProductForm.setSKUs([]);
        }

        // Add pet locket if checked
        if (isPetLocketChecked()) {
          window.LPProductForm.addSKU({
            sku: petLocket.val(),
            quantity: 1,
            name: "Pet Locket",
            price: parsePrice(petLocket.attr("data-price")),
            compareAtPrice: parsePrice(petLocket.attr("data-compare-at-price")),
            sellingPlanId: petLocket.attr("data-selling-plan-id"),
            sellingPlanPercentOff: petLocket.attr("data-subscription-percent-off"),
          });
        }

        // Add second product if active AND primary is also active
        // (if only secondary, it was already set above)
        if (isPrimaryProdActive && isSecondProdActive && currentSecondProdID) {
          const selectedSecondProdEl = $('.second_prod-pack-btns li.active');
          if (selectedSecondProdEl.length) {
            const packNumber = selectedSecondProdEl.find('.second_prod-pack-number').text().trim();
            const packPrice = selectedSecondProdEl.find('input').attr('data-price');
            const packCompareAtPrice = selectedSecondProdEl.find('input').attr('data-compare-at-price');

            window.LPProductForm.addSKU({
              sku: currentSecondProdID,
              quantity: 1,
              name: `Dog Allergy Stickers - ${packNumber}`,
              price: parsePrice(packPrice || selectedSecondProdEl.find('.second_prod-pack-price').text()),
              compareAtPrice: parsePrice(packCompareAtPrice || packPrice || selectedSecondProdEl.find('.second_prod-pack-price').text()),
            });
            log.info(`Added second product to cart: ${currentSecondProdID}`);
          }
        }

        updateTotals()
      }

      // Make updateForm accessible to second product handlers
      updateFormCallback = updateForm;

      // Primary pack click handler with deselection support
      $('.packs').on('click', function(e) {
        const clickedPack = $(this);
        const radioInput = clickedPack.find('input[type="radio"]');
        const wasChecked = radioInput.is(':checked');

        if (wasChecked) {
          // Only allow deselection if secondary is active
          if (!isSecondProdActive) {
            log.info("Cannot deselect primary product - at least one product required");
            e.preventDefault();
            return false;
          }

          // Deselect the primary pack
          radioInput.prop('checked', false);
          clickedPack.removeClass('active');
          currentPrimaryProdID = '';
          isPrimaryProdActive = false;
          log.info("Primary product deselected");
          updateForm();
        } else {
          // Select this pack
          $('.packs input[type="radio"]').prop('checked', false);
          $('.packs').removeClass('active');
          radioInput.prop('checked', true);
          clickedPack.addClass('active');
          currentPrimaryProdID = radioInput.attr('data-tick-id');
          isPrimaryProdActive = true;
          log.info(`Primary product selected: ${currentPrimaryProdID}`);

          // If bundle pack (value="5") is selected, deselect secondary product
          if (radioInput.val() === "5") {
            $('.second_prod-pack-btns li').removeClass('active');
            currentSecondProdID = '';
            isSecondProdActive = false;
            log.info("Bundle selected - secondary product deselected");
          }

          updateForm();
        }

        return false;
      });

      // Initialize primary product state
      const initialPrimaryRadio = $('.packs input[type="radio"]:checked');
      if (initialPrimaryRadio.length) {
        currentPrimaryProdID = initialPrimaryRadio.attr('data-tick-id');
        isPrimaryProdActive = true;
        initialPrimaryRadio.closest('.packs').addClass('active');
      }

      updateForm();
  
      const PRIMARY_COLOR = "#337C6B";
      $("#petlocket").on("change", function () {
        updateForm();
        if ($(this).is(":checked")) {
          $(this)
            .closest(".purchase__pet-locket")
            .css("border", `2px solid ${PRIMARY_COLOR}`);
          log.info("Pet locket checked");
        } else {
          $(this)
            .closest(".purchase__pet-locket")
            .css("border", "2px solid #F0F0F4");
          log.info("Pet locket unchecked");
        }
      });
  
      $("#proceed").click(async function (event) {
        event.preventDefault();
        log.info("Form submission intercepted");
        await window.LPProductForm.submitCart();
      });
  
      log.success("initFormBindings() - Form initialization complete");
    }
  
    // Check if LPProductForm is available and initialized
    if (window.LPProductForm?.isInitialized) {
      // initFormBindings();
      initSecondProdHandlers();
    } else {
      // If not immediately available, wait for it
      var checkInterval = setInterval(function () {
        if (window.LPProductForm?.isInitialized) {
          clearInterval(checkInterval);
          // initFormBindings();
          initSecondProdHandlers();
        }
      }, 100);
    }

    initTooltips();
    initScrolling();

});
  